<template lang="pug">

q-header.bg-grey-2
  q-toolbar.q-pa-md
    q-icon.q-mr-md(name="photo_camera_front" size="md" color="amber-8")
    .text-h4.text-black <router-link class="text-primary" to="/home">CHeKT Ham</router-link> U2M

</template>

<style>
a { 
  text-decoration: none; 
}
</style>

<script>
export default {
}
</script>
